module.exports = __webpack_public_path__ + "static/media/20ECE27.fd0aa85e.jpg";